<comment>
訴求ポイント表示切り替えトグルボタン
グレードのメニューの表示状態により座標が変わる
</comment>

<template>
  <div @mousedown.stop="" class="feature-marker-switch" :class="{positionWithMenu:showGradeList}">
    <button class="feature-marker-switch__toggle" :class="{off:!showFeatureMarker}" @click="displayGradeList(false);featureMarkerVisibleChange(!showFeatureMarker)"></button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'featureSwitch',
  computed: {
    ...mapState([
      'showGradeList',
      'showFeatureMarker'
    ]),
  },
  methods: {
    ...mapActions([
      'featureMarkerVisibleChange',
      'displayGradeList',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.feature-marker-switch{
  padding-left: 61px;
  background: url(../assets/image/fp_base.png) no-repeat;
  position: absolute;
  bottom: 59+14px;
  right: 20px;
  pointer-events: none;
  &.positionWithMenu{
    bottom: 59+171+18px;
  }
  @include size_s{
    bottom: (-16) + 59+14px;
    &.positionWithMenu{
      bottom: (-58) + 59+171+18px;
    }
  }
  &__toggle{
    display: block;//blockにしないと検証機IEでpointer-eventsが効かない
    pointer-events: auto;
    appearance: none;
    border: none;
    width: 61px;
    height: 30px;
    background: url(../assets/image/fp_switch_btn.png) no-repeat;
    background-size: contain;
    cursor: pointer;
    &.off{
      background-image: url(../assets/image/fp_switch_btn2.png);
    }
  }
}
</style>